import {getLoanAphStatusTextByValue} from "./aphLoanUtility";
import {isNullOrUndefined} from "../../../../Utilities/commonUtilities";
import {convertDateToPrintString} from "../../../../Utilities/Types/dateUtilities";
import type { AphLoanItem } from './aphLoan.types';

export const aphLoanItemModel = ({
                                     aphLoanItemId,
                                     aphLoanStatus,
                                     aphLoanNotes,
                                     dateCreatedUtc,
                                     dateFulfilled,
                                     dateFulfilledUtc,
                                     aphCatalogItemId,
                                     aphCatalogNumber,
                                     aphCatalogItemTitle,
                                     aphCatalogItemCost,
                                     aphQueueItemId,
                                     patronFullName,
                                     patronSubType,
                                     patronEmail,
                                     districtName,
                                     organization,
                                     studentFullName,
                                     shippingLocation,
                                     shippingLocationName
                                 }: Record<string, any> = {}): AphLoanItem => ({


    aphLoanItemId,
    aphLoanStatus,
    aphLoanStatusText: getLoanAphStatusTextByValue(aphLoanStatus),
    aphLoanNotes: isNullOrUndefined(aphLoanNotes) ? "" : aphLoanNotes,
    dateCreatedUtc,
    dateCreatedFormatted: convertDateToPrintString(dateCreatedUtc),
    dateFulfilled,
    dateFulfilledUtc,
    aphCatalogItemId,
    aphCatalogNumber,
    aphCatalogItemTitle,
    aphCatalogItemCost,
    aphQueueItemId,
    patronFullName,
    patronSubType,
    patronEmail,
    districtName,
    organization,
    studentFullName,
    shippingLocation,
    shippingLocationName
});

export const updateAphLoanItemModel = ({
                                     aphLoanItemId,
                                     aphLoanStatus,
                                     aphLoanNotes,
                                 }: Partial<AphLoanItem> = {}) => ({


    aphLoanItemId,
    aphLoanStatus,
    aphLoanNotes
});


